import { render } from "./dots-horizontal.vue?vue&type=template&id=6ca87e8f"
import script from "./dots-horizontal.vue?vue&type=script&lang=js"
export * from "./dots-horizontal.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__